if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { InspectorControls, MediaUpload } = window.wp.editor;
    const { PanelBody, Button, TextControl, CheckboxControl } = window.wp.components;

    function renderGallery(attributes, editing) {
        const { images, buttonText, showButton } = attributes;
        const visible = images.slice(0, images.length >= 3 ? 3 : 1);

        function renderImage(image, index) {
            const ImageTag = editing ? 'div' : 'a';
            return (
                <ImageTag key={ image.id } className="gallery-image" href={ editing ? undefined : image.url } data-tour-gallery-index={ editing ? undefined : index } aria-label={ 'Otvori fotografiju: ' + image.alt }>
                    <span
                        className={ 'cover-image bg-dark' + (editing ? '' : ' lozad') }
                        style={ editing ? { backgroundImage: `url(${image.preview})` } : undefined }
                        data-background-image={ editing ? undefined : image.preview }
                        role="img"
                        aria-label={ image.alt }
                    ></span>
                </ImageTag>
            );
        }

        return (
            <div className="tour-gallery" data-tour-gallery-images={ editing ? undefined : JSON.stringify(images.map(image => ({ src: image.url, thumb: image.thumb }))) }>
                <div className="gallery-layout">
                    { visible[0] && renderImage(visible[0], 0) }
                    { visible.length === 3 && <div className="gallery-side">{ visible.slice(1).map((image, index) => renderImage(image, index + 1)) }</div> }
                </div>
                { showButton && images.length > 0 && <button type="button" className="btn btn-dark gallery-button" data-tour-gallery-index={ editing ? undefined : 0 }>{ buttonText } ({ images.length })</button> }
            </div>
        );
    }

    registerBlockType('custom-gutenberg/tour-gallery', {
        title: 'Tour Gallery',
        description: 'Tour image mosaic with a LightGallery lightbox.',
        icon: 'format-gallery',
        category: 'custom-content',
        example: {},
        attributes: {
            images: { type: 'array', default: [] },
            buttonText: { type: 'string', default: 'Pogledaj galeriju' },
            showButton: { type: 'boolean', default: true }
        },

        edit({ attributes, setAttributes }) {
            function onSelectImages(images) {
                setAttributes({ images: images.map(image => ({
                    id: image.id,
                    url: image.sizes && image.sizes.full ? image.sizes.full.url : image.url,
                    preview: image.sizes && image.sizes.large ? image.sizes.large.url : image.url,
                    thumb: image.sizes && image.sizes.thumbnail ? image.sizes.thumbnail.url : image.url,
                    alt: image.alt || image.title || ''
                })) });
            }

            return ([
                <InspectorControls key="settings">
                    <PanelBody title="Gallery images">
                        <MediaUpload
                            multiple
                            gallery
                            type="image"
                            allowedTypes={ ['image'] }
                            value={ attributes.images.map(image => image.id) }
                            onSelect={ onSelectImages }
                            render={ ({ open }) => <Button className="button" onClick={ open }>{ attributes.images.length ? 'Edit gallery' : 'Select images' }</Button> }
                        />
                        { attributes.images.length > 0 && <Button className="button" onClick={ () => setAttributes({ images: [] }) }>Remove images</Button> }
                        <CheckboxControl label="Show gallery button" checked={ attributes.showButton } onChange={ showButton => setAttributes({ showButton: showButton }) } />
                        { attributes.showButton && <TextControl label="Button text" value={ attributes.buttonText } onChange={ buttonText => setAttributes({ buttonText: buttonText }) } /> }
                    </PanelBody>
                </InspectorControls>,
                <div key="preview">
                    { attributes.images.length ? renderGallery(attributes, true) : <p>Select tour images from the Media Library.</p> }
                </div>
            ]);
        },

        save({ attributes }) {
            return attributes.images.length ? renderGallery(attributes, false) : null;
        }
    });
}
